import { getSites } from '../api/get-sites';
import { useSuperQuery } from '@/shared/super/hooks/use-super-query';

export function useSites() {
  return useSuperQuery(() => ({
    queryKey: ['site-settings'],
    queryFn: () => getSites(),
  }));
}
